import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Fieldset from '../../components/Fieldset/Fieldset';
import Grid from '../../components/Grid/Grid';
import ErrorGroupWrapper from './components/ErrorGroupWrapper';
import OptionCardTrigger from './components/OptionCardTrigger';
import * as assets from './assets';
import renderBody from '../../components/RichText/RichText';
import {
  SoftHider,
  FundraisingGroupsWrapper
} from './FundraiserSignup.style';
import { FIELDS, FUNDRAISING_GROUPS } from './constants';
import FundraiserSignupContext from './context/FundraiserSignupContext';

export default function FundraisingGroupCards({
  title,
  description,
  hasDefaultGroup,
  options,
  onGroupChange
}) {
  const { register, getError } = useContext(FundraiserSignupContext);
  const { schoolsImage, workImage, publicImage } = options;

  return (
    <SoftHider show={!hasDefaultGroup} data-test="section-2--group">
      <FundraisingGroupsWrapper>
        <Fieldset legend={title}>
          {description && renderBody(description)}
          <ErrorGroupWrapper errorMessage={getError(FIELDS.GROUP)}>
            <Grid
              xsMobileColumns={1}
              mobileColumns={2}
              columns={3}
              onChange={onGroupChange}
            >
              <OptionCardTrigger
                {...register(FIELDS.GROUP)}
                name={FIELDS.GROUP}
                label="School, early years or youth group"
                value={FUNDRAISING_GROUPS.SCHOOL}
                image={schoolsImage || assets.schoolImg}
                data-test="schools"
              />
              <OptionCardTrigger
                {...register(FIELDS.GROUP)}
                name={FIELDS.GROUP}
                label="Workplace"
                value={FUNDRAISING_GROUPS.WORK}
                image={workImage || assets.workImg}
                data-test="work"
              />
              <OptionCardTrigger
                {...register(FIELDS.GROUP)}
                name={FIELDS.GROUP}
                label="Myself or a group"
                value={FUNDRAISING_GROUPS.PUBLIC}
                image={publicImage || assets.publicImg}
                data-test="public"
              />
            </Grid>
          </ErrorGroupWrapper>
        </Fieldset>
      </FundraisingGroupsWrapper>
    </SoftHider>
  );
}

FundraisingGroupCards.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.shape({ raw: PropTypes.string.isRequired }),
  hasDefaultGroup: PropTypes.bool.isRequired,
  onGroupChange: PropTypes.func.isRequired,
  options: PropTypes.shape({
    schoolsImage: PropTypes.string,
    workImage: PropTypes.string,
    publicImage: PropTypes.string
  }).isRequired
};
